module.exports = __webpack_public_path__ + "img/part_6_6.c0d51388.png";